import { SvgIconType } from './svg.interface';

const Pin: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#A3ACBA'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 6.75H9.75V6C9.75 5.58579 9.41421 5.25 9 5.25H8.625L8.29975 0.696565C8.27172 0.304086 7.94514 0 7.55166 0H4.44834C4.05486 0 3.72828 0.304086 3.70025 0.696565L3.375 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6V6.75Z"
      fill={color}
    />
    <path
      d="M6.02184 11.9989C6.16518 11.9859 6.2775 11.8655 6.2775 11.7188C6.2775 11.66 6.53906 8.25 6.53906 8.25H5.46094C5.46094 8.25 5.715 11.6559 5.715 11.7188C5.715 11.8741 5.84092 12 5.99625 12H6C6.00737 12 6.01466 11.9996 6.02184 11.9989Z"
      fill={color}
    />
  </svg>
);

export default Pin;
